// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0dc40d6f","703":"2e37bc9e"}[chunkId] + ".chunk.js";
};